import Select, { components as RSComponents } from "react-select";

const customStyles = {
  input: (provided, state) => ({
    ...provided,
    height: "37px",
    outline: "transparent",
  }),
  control: (provided, state) => ({
    ...provided,
    outline: "none",
    boxShadow: "none",
    "& input:focus": { outline: "none", boxShadow: "none" },
    borderColor: state.isFocused ? "var(--primary)" : "#d4d4d4",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "var(--primary)" : "transparent",
    color: state.isFocused ? "white" : "var(--primary)",
    "&:hover": { backgroundColor: "var(--primary)", color: "white" },
  }),
  // >>> estes dois garantem que o dropdown fica por cima de tudo
  menuPortal: (base) => ({ ...base, zIndex: 999999 }), // portal no topo
  menu: (base) => ({ ...base, zIndex: 999999 }), // redundância útil
};

const AutoCompleteInput = ({
  noOptionsMessage = "Nenhum registro encontrado",
  options,
  onChange,
  isLoading,
  label,
  name,
  value,
  disabled = false,
  className,
  isClearable = false,
  isMulti = false,
  hideMultiValue = false,
  summaryLabel,
  closeMenuOnSelect,
}) => {
  const selectedOption = (() => {
    if (isMulti) {
      if (!Array.isArray(value) || !options) return [];
      const selectedValues = new Set(value.map((v) => String(v)));
      return options.filter((option) =>
        selectedValues.has(String(option.value))
      );
    }
    return options?.find((option) => option.value == value) || null;
  })();

  const baseComponents = hideMultiValue
    ? {
        MultiValue: () => null,
        MultiValueContainer: () => null,
      }
    : {};

  const shouldCloseMenuOnSelect =
    typeof closeMenuOnSelect === "boolean" ? closeMenuOnSelect : !isMulti;

  const summaryValueActive =
    Boolean(summaryLabel) && isMulti && Array.isArray(value) && value.length > 0;

  const mergedComponents = {
    ...baseComponents,
    ...(summaryValueActive
      ? {
          ValueContainer: (props) => (
            <RSComponents.ValueContainer {...props}>
              <div className="text-xs font-semibold text-slate-600 mb-0.5">
                {summaryLabel}
              </div>
              {props.children}
            </RSComponents.ValueContainer>
          ),
        }
      : {}),
  };

  return (
    <div className="w-full relative flex flex-col gap-1">
      <label htmlFor={name} className="text-sm font-semibold text-gray-700 -mb-5">
        {label}
      </label>
      <Select
        noOptionsMessage={() => noOptionsMessage}
        options={options}
        onChange={onChange}
        placeholder=""
        isLoading={isLoading}
        name={name}
        value={selectedOption || null}
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
        styles={customStyles}
        isDisabled={disabled}
        isClearable={isClearable}
        isMulti={isMulti}
        closeMenuOnSelect={shouldCloseMenuOnSelect}
        components={mergedComponents}
        // >>> chave do “sempre por cima”:
        menuPortalTarget={
          typeof document !== "undefined" ? document.body : null
        }
        menuPosition="fixed"
        // (opcional) melhora estilo default de classes geradas
        classNamePrefix="rs"
        className={`${className}`}
      />
    </div>
  );
};

export default AutoCompleteInput;
